(function () {
  var BUTTON_TEXT = 'Restore My Joints Today';
  var PRODUCT_PATH = '/products/ascetica-moringa';

  function init() {
    var candidates = document.querySelectorAll('a, button');

    candidates.forEach(function (el) {
      if (el.textContent.trim() !== BUTTON_TEXT) return;
      if (el.dataset.restoreJointsBound) return;
      el.dataset.restoreJointsBound = 'true';
      el.addEventListener('click', onClick);
    });
  }

  function onClick(event) {
    // Only act on the actual product page — other pages (like the homepage)
    // may have their own unrelated add-to-cart button (e.g. a Featured
    // Product section) that happens to match the same ID pattern.
    var isProductPage = window.location.pathname.indexOf(PRODUCT_PATH) !== -1;
    if (!isProductPage) return;

    var submitButton = document.querySelector('[id^="ProductSubmitButton-"]');
    if (!submitButton || submitButton.disabled) return;

    event.preventDefault();

    var forceTierValue = event.currentTarget.dataset.restoreTier;

    if (forceTierValue) {
      var tierRadio = document.querySelector('.bundle-picker__input[value="' + forceTierValue + '"]');

      if (tierRadio && !tierRadio.checked) {
        tierRadio.checked = true;
        tierRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    submitButton.click();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
